import { Component, input, output, TemplateRef, viewChild, inject } from '@angular/core';
import { DialogActionsComponent, DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { TableComponent } from '../table/table.component';
import { ButtonComponent, DropDownButtonComponent } from '@progress/kendo-angular-buttons';
import { CapitalizePipe, ClientInvoiceStatusBadgePipe } from '../../../pipes';
import { TranslateModule } from '@ngx-translate/core';
import { TableConfig } from '../table-config';
import { AsyncPipe, NgTemplateOutlet, UpperCasePipe } from '@angular/common';
import { CellTemplateDirective, ColumnComponent } from '@progress/kendo-angular-grid';
import { DatePipe, NumberFormatOptions, NumberPipe } from '@progress/kendo-angular-intl';
import { BadgeComponent } from '../../badge/badge.component';
import { Entity } from '../../../models';
import { AMOUNT_FORMAT } from '../../../constants';

@Component({
  selector: 'rc-table-modal',
  imports: [
    TableComponent,
    ButtonComponent,
    CapitalizePipe,
    DialogActionsComponent,
    TranslateModule,
    AsyncPipe,
    CellTemplateDirective,
    ColumnComponent,
    DropDownButtonComponent,
    DatePipe,
    NgTemplateOutlet,
    NumberPipe,
    UpperCasePipe,
    BadgeComponent,
    ClientInvoiceStatusBadgePipe,
    ClientInvoiceStatusBadgePipe,
    ClientInvoiceStatusBadgePipe,
  ],
  providers: [],
  templateUrl: './table-modal.component.html',
  styleUrl: './table-modal.component.scss',
})
export class TableModalComponent<T> extends DialogContentBase {
  tableConfig = input.required<TableConfig<any>>();

  table = viewChild<TableComponent<Entity>>(TableComponent);

  // Expose the templates to the parent
  clientInvoiceModal = viewChild<TemplateRef<any>>('clientInvoiceModal');
  supplierInvoiceModal = viewChild<TemplateRef<any>>('supplierInvoiceModal');
  clientCreditNoteModal = viewChild<TemplateRef<any>>('clientCreditNoteModal');
  clientInvoiceItemModal = viewChild<TemplateRef<any>>('clientInvoiceItemModal');
  supplierInvoiceItemModal = viewChild<TemplateRef<any>>('supplierInvoiceItemModal');

  closeEvent = output<boolean>();

  decimalFormat: NumberFormatOptions = {
    style: 'decimal',
    maximumFractionDigits: 3,
    minimumFractionDigits: 2,
  };
  protected readonly amountFormat = AMOUNT_FORMAT;

  constructor() {
    const dialog = inject(DialogRef);

    super(dialog);
  }

  getPropField(item: any): string {
    return (item['@type']).replace(/^./, (c: string) => c.toLowerCase());
  }

  close() {
    this.closeEvent.emit(true);
  }
}
